module.exports = __webpack_public_path__ + "static/media/CB.81300f07.svg";